import { Injectable, inject } from '@angular/core';
import * as _ from 'lodash-es';
import { ResolverService } from './api/resolver.service';
import { KFeathers } from './api/feathers.service';
import { Marque } from '../models/marque.model';


@Injectable({
    providedIn: 'root',
})
export class MarqueService extends ResolverService<Marque> {
    protected feathers: KFeathers;

    path: string = 'marques';
    model: new (any: any) => Marque = Marque;

    constructor() {
 const feathers = inject(KFeathers);
 super(feathers); 
 this.feathers = feathers;
    }

}
